/**
 * Arena Pet Bowl Set - 颜色和Finish可用配置
 */

(function() {
  'use strict';

  // 🎯 每个颜色支持的Finish类型
  const COLOR_FINISH_SUPPORT = {
    // ✅ 正确逻辑：Arena（罗马柱碗）缺少 Black / Yellow / BabyBlue 的 matte
    // MuseStand 是否允许这些颜色的 matte 由其自身脚本控制，这里只体现 Arena 的物理配置
    'black': { glossy: true, matte: false },
    'white': { glossy: true, matte: true },
    'pink': { glossy: true, matte: true },
    'babyblue': { glossy: true, matte: false },
    'yellow': { glossy: true, matte: false },
    'babyyellow': { glossy: true, matte: false }, // Yellow 的别名
    'cyan': { glossy: true, matte: false },      // 只有亮面
    'navyblue': { glossy: true, matte: false },  // 只有亮面
    'navy': { glossy: true, matte: false },      // Globo插件简写
    'orange': { glossy: true, matte: false },    // 只有亮面
    'green': { glossy: true, matte: false },     // 只有亮面
    'purple': { glossy: true, matte: false },    // 只有亮面
    'purplehaze': { glossy: true, matte: false }, // Globo插件变体
    'red': { glossy: true, matte: false },       // 只有亮面
    'brown': { glossy: true, matte: false }      // 只有亮面
  };

  /**
   * 检查指定颜色是否支持指定finish
   */
  function supportsFinish(color, finish) {
    const colorKey = color.toLowerCase().replace(/\s+/g, '');
    const support = COLOR_FINISH_SUPPORT[colorKey];
    if (!support) return true; // 默认支持
    return finish === 'glossy' ? support.glossy : support.matte;
  }

  /**
   * 检查Top + Bottom组合是否支持指定finish组合
   */
  function isFinishCombinationAvailable(topColor, bottomColor, topFinish, bottomFinish) {
    const topSupports = supportsFinish(topColor, topFinish);
    const bottomSupports = supportsFinish(bottomColor, bottomFinish);
    return topSupports && bottomSupports;
  }

  /**
   * 获取可用的Finish选项
   */
  function getAvailableFinishOptions(topColor, bottomColor) {
    const options = [
      { value: 'Glossy + Glossy', topFinish: 'glossy', bottomFinish: 'glossy' },
      { value: 'Matte + Matte', topFinish: 'matte', bottomFinish: 'matte' },
      { value: 'Glossy + Matte', topFinish: 'glossy', bottomFinish: 'matte' },
      { value: 'Matte + Glossy', topFinish: 'matte', bottomFinish: 'glossy' }
    ];

    return options.map(opt => ({
      ...opt,
      available: isFinishCombinationAvailable(topColor, bottomColor, opt.topFinish, opt.bottomFinish)
    }));
  }

  // 暴露到全局
  window.ArenaFinishConfig = {
    supportsFinish: supportsFinish,
    isFinishCombinationAvailable: isFinishCombinationAvailable,
    getAvailableFinishOptions: getAvailableFinishOptions,
    colorSupport: COLOR_FINISH_SUPPORT
  };

  console.log('✅ [Arena] Finish配置已加载');

})();
